export default "__VITE_PUBLIC_ASSET__b2895a4c__"